import { Box, Button, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from '@mui/material/styles';
import { FC, ReactNode } from 'react';
import { BaseModal } from '~/components/modals/BaseModal/BaseModal.tsx';
import AlertTriangle from '~/components/icons/AlertTriangle.tsx';
import { styles } from './styles.ts';

interface IModalAlertProps {
  isOpen: boolean;
  text: string | ReactNode;
  buttonValue?: string;
  onClick?: () => void;
  onClose: () => void;
  dataTestId?: string;
}

const ModalAlert: FC<IModalAlertProps> = ({
  isOpen,
  text,
  buttonValue,
  onClick,
  onClose,
  dataTestId,
}) => {
  const theme = useTheme();

  if (!isOpen) return null;

  const handleModalClose = (_event: object, reason: 'backdropClick' | 'escapeKeyDown'): void => {
    if (reason === 'backdropClick') {
      onClose();
    }
  };

  return (
    <BaseModal
      open={isOpen}
      onClose={handleModalClose}
      sx={styles.modal}
      slotProps={{ backdrop: { sx: styles.backdrop } }}
      containerProps={{
        sx: styles.paper(theme),
      }}
    >
      <IconButton aria-label="close" onClick={onClose} sx={styles.closeButton}>
        <CloseIcon fontSize="small" />
      </IconButton>
      <Box sx={styles.content} data-testid={dataTestId}>
        <AlertTriangle variant="alert" size={60} aria-hidden="true" />
        <Typography sx={styles.text}>{text}</Typography>
      </Box>
      {buttonValue && (
        <Box sx={styles.actions}>
          <Button variant="contained" size="large" onClick={onClick}>
            {buttonValue}
          </Button>
        </Box>
      )}
    </BaseModal>
  );
};

export default ModalAlert;
